<template>
    <!-- Sidebar -->
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

      <!-- Sidebar - Brand -->
      <a class="navbar-brand sidebar-brand d-flex align-items-center justify-content-center" href="/">
        <!-- <div class="sidebar-brand-icon rotate-n-15">
          <i class="fas fa-laugh-wink"></i>
        </div> -->
        <div class="sidebar-brand-icon" v-if="showlogo && logopath">
          <img class='rounded' :src="logopath"  style="width:45px;"/>
        </div>
        <div class="sidebar-brand-text mx-3">{{appname}}</div>
      </a>

      <!-- Divider -->
      <hr class="sidebar-divider my-0">

      <!-- Heading -->
      <div class="sidebar-heading" v-if="currentUser!=null && userProfile!=null && userProfile.role=='teacher'">
        Багш
      </div>
        <!-- Nav Item - Dashboard -->
        <router-link to="/dashboard" class="nav-item">
              
                <a class="nav-link" href="">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>Dashboard</span>
                </a>
        </router-link>
      <!-- Nav Item - Pages Collapse Menu -->
      
        <router-link to="/hello" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='teacher' || userProfile.role=='sts' || userProfile.role=='admin' || userProfile.role=='superadmin')">
            <a class="nav-link" >
            <i class="fas fa-book-open"></i>
            <span>Миний хичээлүүд</span>
            </a>
        </router-link>


        <router-link to="/globalqa" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='teacher' || userProfile.role=='lesson_manager')">
            <a class="nav-link" >
            <i class="fas fa-question-circle"></i>
            <span>Санал хүсэлт</span>
            </a>
        </router-link>

      <!-- Divider -->
      <hr class="sidebar-divider">

      <!-- Heading -->
      <div class="sidebar-heading" v-if="currentUser!=null && userProfile!=null && userProfile.role=='student'">
        Оюутан
      </div>

      <router-link to="/lessons" class="nav-item" v-if="currentUser!=null && userProfile!=null && userProfile.role=='student'">
        <a class="nav-link" >
          <i class="fas fa-book"></i>
          <span>Миний сонгосон хичээлүүд</span>
        </a>
      </router-link>


      <!-- Divider -->
      <hr class="sidebar-divider d-none d-md-block" v-if="currentUser!=null && userProfile!=null && userProfile.role=='student'">
      <!-- Heading -->
      <div class="sidebar-heading" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='lesson_manager' || userProfile.role=='superadmin')">
        ADMIN
      </div>

      <!-- Nav Item - Pages Collapse Menu -->

      <router-link to="/subschools" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='lesson_manager' || userProfile.role=='superadmin')">
        <a class="nav-link" >
          <i class="fas fa-school"></i>
          <span>Бүрэлдэхүүн сургууль</span>
        </a>
      </router-link>


      <!-- Divider -->
      <hr class="sidebar-divider d-none d-md-block" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='lesson_manager' || userProfile.role=='superadmin')">

      <!-- Heading -->
      <div class="sidebar-heading" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='superadmin')">
        Бүртгэл
      </div>

      <!-- Nav Item - Pages Collapse Menu -->
       <router-link to="/teachers" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='lesson_manager' || userProfile.role=='superadmin')">
            <a class="nav-link" >
            <i class="fas fa-chalkboard-teacher"></i>
            <span>Багш</span>
            </a>
        </router-link>
         <router-link to="/students" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='superadmin')">
            <a class="nav-link" >
            <i class="fas fa-user-graduate"></i>
            <span>Оюутнууд</span>
            </a>
        </router-link>

   <router-link to="/prestudents" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
            <a class="nav-link" >
            <i class="fas fa-user-graduate"></i>
            <span>Шинэ оюутнууд</span>
            </a>
        </router-link>
      <!-- Nav Item - Pages Collapse Menu -->

  

        <!-- <router-link to="/alllessons" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
            <a class="nav-link" >
            <i class="fas fa-star"></i>
            <span>Хичээлүүд</span>
            </a>
        </router-link> -->
 
        <router-link to="/news" class="nav-item" v-if="grad==true && currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
            <a class="nav-link" >
            <i class="far fa-newspaper"></i>
            <span>Мэдээ</span>
            </a>
        </router-link>

        <router-link to="/announcement" class="nav-item" v-if="grad==true && currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
            <a class="nav-link" >
            <i class="far fa-calendar-alt"></i>
            <span>Хуанли</span>
            </a>
        </router-link>
        <router-link to="/programs" class="nav-item" v-if="grad==true && currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
            <a class="nav-link" >
            <i class="far fa-calendar-alt"></i>
            <span>Хөтөлбөрүүд</span>
            </a>
        </router-link>
  
        <router-link to="/admins" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='superadmin')">
            <a class="nav-link" >
            <i class="fas fa-users-cog"></i>
            <span>Админууд</span>
            </a>
        </router-link>
     <hr class="sidebar-divider">
        <div class="sidebar-heading" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='teacher' || userProfile.role=='lesson_manager' || userProfile.role=='manager' || userProfile.role=='superadmin')">
          Тогтмол мэдээлэл
        </div>


        <router-link to="/lessontypes" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='teacher' || userProfile.role=='lesson_manager' || userProfile.role=='superadmin')">
            <a class="nav-link" >
            <i class="fas fa-list-alt"></i>
            <span>Хичээлийн төрөл</span>
            </a>
        </router-link>
        <router-link to="/cities" class="nav-item" v-if="currentUser!=null && userProfile!=null && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager' || userProfile.role=='superadmin')">
          <a class="nav-link" >
            <i class="fas fa-school"></i>
            <span>Хот/Дүүрэг</span>
          </a>
        </router-link>
        <hr class="sidebar-divider">
        <div class="sidebar-heading" v-if="grad!=true && currentUser!=null && userProfile!=null && (userProfile.role=='superadmin' || userProfile.role=='finance')">
          Санxүүгийн алба
        </div>
        <router-link to="/accounts" class="nav-item" v-if="grad!=true && currentUser!=null && userProfile!=null && (userProfile.role=='superadmin' || userProfile.role=='finance')">
            <a class="nav-link" >
            <i class="fas fa-university"></i>
            <span>Данс шалгаx</span>
            </a>
        </router-link>

        <router-link to="/finance/list" class="nav-item" v-if="grad!=true && currentUser!=null && userProfile!=null && (userProfile.role=='superadmin'  || userProfile.role=='finance')">
            <a class="nav-link" >
            <i class="fas fa-money-check"></i>
            <span>Төлбөрийн мэдээлэл</span>
            </a>
        </router-link>
        

      <!-- Divider -->
      <hr class="sidebar-divider d-none d-md-block" v-if="currentUser!=null && userProfile!=null && userProfile.role=='admin'">

      

      <!-- Sidebar Toggler (Sidebar) -->
      <div class="text-center d-none d-md-inline">
        <button class="rounded-circle border-0" id="sidebarToggle" @click="toggleSideBar"></button>
      </div>

    </ul>
    <!-- End of Sidebar -->
</template>

<script>
import { mapState } from 'vuex';
import mixin from './global/mixin.js';
const fb = require("../firebaseConfig.js");

export default {
    name: 'Navigation',
    mixins: [mixin],
    data() {
      return {
        appname: null,
        showlogo: null,
        logopath:null,
        grad:true
      };
    },
    methods: {
      
    },
    computed: {
      ...mapState(['currentUser', 'userProfile'])
    },
    created(){
      if(fb.APPNAME)
        this.appname=fb.APPNAME;
      if(fb.SHOWLOGO)
        this.showlogo=fb.SHOWLOGO;
      if(fb.LOGOPATH)
        this.logopath=fb.LOGOPATH;
      if(fb.SHOW_GRAD_FORM==true){
        this.grad=true;
      }
      else{
        this.grad=false;
      }
    }
}
</script>